import React from "react";

import { IgListItemButton, IgRadio, IgTypography } from "@intelligems/ig-theme";
import { DeviceType } from "@intelligems/ig-types";
import { Grid } from "@mui/material";

import { deviceTypeList } from "../utils";

interface DeviceRadioProps {
  onClick: (arg1: any, arg2: any) => void;
  deviceType?: DeviceType | null;
  isView?: boolean;
}

export const DeviceRadio = ({
  deviceType,
  onClick,
  isView,
}: DeviceRadioProps) => {
  const selectedRadio = (selectedDeviceType: string): boolean => {
    return deviceType === selectedDeviceType;
  };

  return (
    <Grid container direction={"column"}>
      {deviceTypeList.map((deviceType, index: number) => (
        <Grid
          item
          key={deviceType.key}
          onClick={() => {
            onClick(deviceType.key, "deviceType");
          }}
          sx={{ "& :hover": { cursor: "pointer" } }}
        >
          <IgRadio
            label={deviceType.label}
            disabled={isView}
            checked={selectedRadio(deviceType.key)}
          />
        </Grid>
      ))}
    </Grid>
  );
};
